@if (imgSrc()) {
    <img
        class="thumbnail"
        [src]="imgSrc()"
        [title]="selectedFile().file.name"
        [alt]="selectedFile().file.name"
    />
} @else {
    <i [ctrlIcon]="icon()"></i>
}
<div class="file-details">
    <p class="flex fw:semibold m-0:b">
        @if (splittedFileName().length === 3) {
            <span class="ellipsify">{{ splittedFileName()[1] }}</span>
            <span class="extension">{{ splittedFileName()[2] }}</span>
        } @else {
            {{ selectedFile().file.name }}
        }
    </p>
    <p class="fs:s m-0:b">{{ docType().description ?? 'Sonstige' }}</p>
</div>
<app-kebab-menu
    class="menu"
    [context]="selectedFile()"
    [menuItems]="menuItems"
></app-kebab-menu>
